import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import * as crypto from 'crypto-js';
import { UserDTO } from 'src/app/data/dto/UserDTO';
import { AuthenticationService } from '../_service/auth.service';
import { User } from '../_model/User';
declare var $: any;

@Component({
selector: 'app-login',
styleUrls: ['./login.component.scss'],
templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {
loginForm: FormGroup;
loading = false;
submitted = false;
loginerror = false;
returnUrl: string;
musername: string;

constructor(
private formBuilder: FormBuilder,
private route: ActivatedRoute,
private router: Router,
private authenticationService : AuthenticationService,
private toastr: ToastrService
) { }
onTidioChatApiReady() {
    window.tidioChatApi.hide();
    window.tidioChatApi.on("close", function() {
    window.tidioChatApi.hide();
    });
    $("#offers").hide();
    $("#ModalPromotions").remove();
}
ngOnInit() {    
    $("#offers").hide();
    $("#ModalPromotions").remove();
    $("#loginModal").modal({backdrop: 'static', keyboard: false}, 'show');
    if (window.tidioChatApi) {
    window.tidioChatApi.on("ready", this.onTidioChatApiReady);
    } else {
    document.addEventListener("tidioChat-ready", this.onTidioChatApiReady);
    }
    const scrolling = document.querySelector('.container');
    scrolling.scrollIntoView({ behavior: 'smooth', block: 'start' });
    this.loginForm = this.formBuilder.group({
    email: ['', Validators.required],
    password: ['', Validators.required]
    });
        
    if(this.route.snapshot.queryParamMap.get('token')){
        let $this = this;
        setTimeout(async function(){
            let token = atob($this.route.snapshot.queryParamMap.get('token'));
            await (await $this.authenticationService.login(token.split("|")[0], token.split("|")[1].toString()))
            .subscribe(
                data => {
                    console.log("data",data);
                    if(data == null || typeof(data) === undefined){
                        $this.loginerror = true;
                    }else{
                        $this.loading = false;
                        window.location.href = "/cotizacion";
                    }
                
            },
            error => {
                $this.toastr.error(error.error.message, 'Login Error');

            });
        },0);                
    }
    
}
 
// for accessing to form fields
get fval() { return this.loginForm.controls; }
 
async onFormSubmit() {
    this.submitted = true;
    if (this.loginForm.invalid) {
        return;
    }
 
    this.loading = true;
    //encriptar password
    var iv = crypto.enc.Hex.parse("6e5Wa23fYoT7MFAG");    
    var secretKey:any = 'ISIIX%21';
    let passwordencrypt:any = crypto.AES.encrypt(this.fval.password.value, secretKey.trim(), {
      iv: iv,
      mode: crypto.mode.CBC,
      padding: crypto.pad.Pkcs7
    }).toString();
    var email: string = this.fval.email.value;
    //let usrreq = 
    await (await this.authenticationService.login(email, passwordencrypt.toString()))

    .subscribe(
        data => {
            if(data == null || typeof(data) === undefined){
                this.loginerror = true;
                this.loading = false;
            }else{
                window.tidioChatApi.show();
                //Se comenta muestra del boton para modal de ofertas
                //$("#offers").show();
                this.router.navigate(['/cotizacion']);
            }
        
    },
    error => {
        this.toastr.error(error.error.message, 'Login Error');
        this.loading = false;
    });
    
}
}